import { useEffect } from "react";
import Pprocess from '../table/Tablepprocess';
import Modal from "../modal/Modalprpocess"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Pprocess/>
    
     
     </>
  );
};

export default Dashboard;
